export const HOMEPAGE_REVIEWS = {
  headingLine1: 'Over 30,000',
  headingLine2Accent: '5-star',
  headingLine2Rest: ' reviews',
}

export const RECIPE_VIDEOS = [
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt55597cd1408553e0/6a68d1feb9c69a4d8bf6c69c/green_goodness_bowl.mp4',
    recipeName: 'Green Goodness Bowl With Boiled Egg And Sweet Potato',
    rating: '4.5',
    tile: 'green_goodness',
  },
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt1acec7383b66ebad/6a68d1f0280bf3d99b48dc31/fish_&_chips_and_crushed_peas.mp4',
    recipeName: 'Ultimate Fish & Chips With Stout-Battered Sole And Crushed Peas',
    rating: '4.6',
    tile: 'fish_and_chips',
  },
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt8955d60aa256a135/6a69b826c251c9b2dbbf3d74/slow_cooked_beef_brisket_birra_tacos.mp4',
    recipeName: 'Slow Cooked Beef Brisket Birria Tacos',
    rating: '5.0',
    tile: 'beef_brisket',
  },
]
